import { Store } from "@jaybeeuu/recoilless";
import { h, createContext } from "preact";
import { useContext, useMemo } from "preact/hooks";
const StoreContext = createContext(new Store());
export const StoreProvider = ({ store, children }) => {
    const defaultedStore = useMemo(() => store ?? new Store(), [store]);
    return (h(StoreContext.Provider, { value: defaultedStore }, children));
};
StoreProvider.displayName = "StoreProvider";
export const useStore = () => useContext(StoreContext);
//# sourceMappingURL=store-provider.js.map